import type { PagingRequest } from '#/api/type'

import { defineApi } from '#/api/define-api'
import { requestClient } from '#/api/request'

export interface ExportCenterQueryParams {
  taskId?: number | string
}

export interface ExportCenterDownloadParams {
  taskId: number
}

export interface ExportCenterDownloadResponse {
  downloadUrl: string
  expireSeconds: number
}

export interface ExportCenterRawItem {
  bizCode?: string
  createdBy?: string
  endTime?: string
  errorMsg?: string
  fileName?: string
  fileSize?: number
  startTime?: string
  status?: number
  taskId?: number
}

export interface ExportCenterItem {
  createdBy?: string
  endTime?: string
  errorMsg?: string
  fileName?: string
  startTime?: string
  status?: number
  taskId?: number
}

export interface ExportCenterQueryResponse {
  list: ExportCenterRawItem[]
  total?: number
}

export const exportCenterApi = defineApi('operation', ({ prefix }) => {
  function queryExportTaskList(params: PagingRequest<ExportCenterQueryParams>) {
    return requestClient
      .post<ExportCenterQueryResponse>(prefix('export/query'), {
        pageIndex: params.pageIndex,
        pageSize: params.pageSize,
        taskId: params.condition.taskId,
      })
      .then((res) => ({
        items: res.list.map(
          (item): ExportCenterItem => ({
            createdBy: item.createdBy,
            endTime: item.endTime,
            errorMsg: item.errorMsg,
            fileName: item.fileName,
            startTime: item.startTime,
            status: item.status,
            taskId: item.taskId,
          }),
        ),
        total: res.total,
      }))
  }

  /**
   * 获取导出文件的签名下载地址。
   * POST /export/download
   */
  function getExportTaskDownloadUrl(params: ExportCenterDownloadParams) {
    return requestClient
      .post<ExportCenterDownloadResponse>(prefix('export/download'), {
        taskId: params.taskId,
      })
      .then((data) => ({
        downloadUrl: data.downloadUrl,
        expireSeconds: data.expireSeconds,
      }))
  }

  return {
    getExportTaskDownloadUrl,
    queryExportTaskList,
  }
})
